<ng-template #container let-modal>
    <div class="modal-header d-flex align-items-center">
        <h4 class="modal-title" id="modal-basic-title">{{'popup.'+type+'.title' | translate}}</h4>
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form (submit)="sendEvent()">
        <div class="modal-body">
            <span>{{'popup.'+type+'.body' | translate}}</span>
        </div>
        <div class="modal-footer gap-2">
            <button type="submit" class="btn btn-success">{{'popup.confirm' | translate}}</button>
            <button type="button" (click)="close()" class="btn btn-danger">{{'popup.cancel' | translate}}</button>
        </div>
    </form>
</ng-template>